import { put } from 'redux-saga/effects'
import { Campaign } from '@/models/campaign.model'
import { fetchManyByCampaignIdsAction } from '../../handles'
import { fetchManyByCampaignIds } from '../_http/campaign'

type ApiResponse = {
  campaigns?: Campaign[]
  campaign?: Campaign
}

export function* fetchManyByCampaignIdsSaga(action: ReturnType<typeof fetchManyByCampaignIdsAction.request>) {
  try {
    const { campaignIds, ownerId } = action.payload
    const response: ApiResponse = yield fetchManyByCampaignIds({
      campaignIds,
      ownerId
    })

    let campaigns: Campaign[] = []
    if (response.campaigns && Array.isArray(response.campaigns)) {
      campaigns = response.campaigns
    } else if (response.campaign) {
      campaigns = [response.campaign]
    }

    yield put(fetchManyByCampaignIdsAction.success({ campaigns }))
  } catch (error) {
    // Silent fail - connection status will use fallback data
  }
}
